import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/utils/cn'
import { type PipelineStage, STAGE_TONE } from './pipeline-stage'

export function PipelineStageCard({
  stage,
  title,
  description,
}: {
  stage: PipelineStage
  title: string
  description: string
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-3 text-sm">
          <div className={cn('w-3 h-3 rounded-full', STAGE_TONE[stage].dot)} />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <CardDescription>{description}</CardDescription>
      </CardContent>
    </Card>
  )
}
